import React, { useEffect, useState } from "react";
import axios from "axios";
import API_BASE_URL from "../config";

const ApproveLeaveRequests = () => {
  const [leaves, setLeaves] = useState([]);
  const [loading, setLoading] = useState(true);

  const styles = {
    container: {
      maxWidth: "800px",
      margin: "40px auto",
      padding: "20px",
      borderRadius: "10px",
      backgroundColor: "#f9f9f9",
      boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
      fontFamily: "Segoe UI, sans-serif",
    },
    title: {
      fontSize: "24px",
      textAlign: "center",
      marginBottom: "20px",
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
    },
    th: {
      borderBottom: "2px solid #ccc",
      padding: "10px",
      textAlign: "left",
      backgroundColor: "#e5e7eb",
    },
    td: {
      padding: "10px",
      borderBottom: "1px solid #ddd",
    },
    button: {
      padding: "8px 12px",
      backgroundColor: "#10b981",
      color: "white",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
    },
  };

  useEffect(() => {
    axios.get(`${API_BASE_URL}/api/leaves`)
      .then(response => {
        setLeaves(response.data);
        setLoading(false);
      })
      .catch(error => {
        console.error("Error fetching leaves:", error);
        setLoading(false);
      });
  }, []);

  const handleApprove = (id) => {
    axios.put(`${API_BASE_URL}/api/leaves/${id}/approve`)
      .then(() => {
        setLeaves(prev =>
          prev.map(leave =>
            leave.id === id ? { ...leave, status: "Approved" } : leave
          )
        );
      })
      .catch(error => console.error("Approval error:", error));
  };

  return (
    <div style={styles.container}>
      <div style={styles.title}>✅ Approve Leave Requests</div>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>Employee</th>
              <th style={styles.th}>Type</th>
              <th style={styles.th}>Dates</th>
              <th style={styles.th}>Reason</th>
              <th style={styles.th}>Status</th>
              <th style={styles.th}>Action</th>
            </tr>
          </thead>
          <tbody>
            {leaves.map((leave) => (
              <tr key={leave.id}>
                <td style={styles.td}>{leave.employeeName || "N/A"}</td>
                <td style={styles.td}>{leave.leaveType}</td>
                <td style={styles.td}>{leave.startDate} to {leave.endDate}</td>
                <td style={styles.td}>{leave.reason}</td>
                <td style={styles.td}>{leave.status || "Pending"}</td>
                <td style={styles.td}>
                  {leave.status === "Approved" ? (
                    "✔️ Approved"
                  ) : (
                    <button style={styles.button} onClick={() => handleApprove(leave.id)}>
                      Approve
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default ApproveLeaveRequests;
